export const PURCHASE_ORDER_STATUSES = ['DRAFT', 'ORDERED', 'PARTLY_RECEIVED', 'RECEIVED', 'CANCELLED'] as const;
export type PurchaseOrderStatus = (typeof PURCHASE_ORDER_STATUSES)[number];

/** Orders the bar is still waiting on: their lines count as stock on the way when reordering. */
export const PURCHASE_ORDER_INCOMING_STATUSES = ['DRAFT', 'ORDERED', 'PARTLY_RECEIVED'] as const satisfies readonly PurchaseOrderStatus[];
